import styled from 'styled-components/native'
import { Metrics, Colors, Fonts } from 'APP/Themes'
import { isMobile } from 'APP/Helpers/checkPlatform'
import Typography from 'APP/Converse/Typography'

export const Wrapper = styled.View`
  justify-content: center;
`

export const IconWrapper = styled.View`
  position: relative;
  justify-content: center;
  align-items: center;
`

export const Badge = styled.View`
  position: absolute;
  top: ${isMobile() ? `${Metrics.baseMargin * 0.2}px` : '10%'};
  right: ${Metrics.baseMargin * 1.4}px};
  background-color: ${Colors.errorSnackBarBg};
  border-radius: 9px;
  min-width: 18px;
  height: 18px;
  padding: 0 ${Metrics.baseMargin * 0.3}px;
  justify-content: center;
  align-items: center;
`

export const BadgeText = styled(Typography)`
  color: ${Colors.elementsBg};
  ${Fonts.style.captionBold};
`
